import { upperCaseEveryFirstLetter } from '@fergdigitalcommerce/fergy-utilities';
import { type QuickStartResultFieldsFragment } from '../../__generated__/graphql-client-types';
import { type QuickStartImageGridLook, type ShopByLookRoom, type ShopByLookStyle } from '../../types/project.types';

const DEFAULT_ROOM_IMAGE_BASE_URL = 'mediabase/site/build.com/images/projects/checklists';

export const generateRoomImagePublicId = (iconName: string) => {
	return `${DEFAULT_ROOM_IMAGE_BASE_URL}/${iconName}.svg`;
};

export const formatKebabTag = (tag: string) =>
	tag
		.split('-')
		.map((str) => upperCaseEveryFirstLetter(str))
		.join('-');

export const formatFilterTag = (tagType: 'Room' | 'Style', tag: string): ShopByLookRoom | ShopByLookStyle => {
	// uppercase func transforms 'mid-century modern' => 'Mid-century Modern'
	// this will handle the dash to format tag correctly to 'Mid-Century Modern'
	if (tag.split('-').length > 1) {
		const dashedTag = formatKebabTag(tag);
		return { name: tagType, value: dashedTag };
	}
	return { name: tagType, value: upperCaseEveryFirstLetter(tag) };
};

export const fillTagFilterArray = (rooms: string[], styles: string[]): (ShopByLookRoom | ShopByLookStyle)[] => {
	const tagArray: (ShopByLookRoom | ShopByLookStyle)[] = [];

	if (rooms.length) {
		rooms.forEach((room) => tagArray.push(formatFilterTag('Room', room)));
	}
	if (styles.length) {
		styles.forEach((style) => tagArray.push(formatFilterTag('Style', style)));
	}

	return tagArray;
};

export const convertQuickStartsToSimpleLooks = (quickStarts: QuickStartResultFieldsFragment[]): QuickStartImageGridLook[] =>
	quickStarts.map((look) => {
		return {
			url: `/account/projects/${look.projectId}/showcase`,
			imageId: look.featuredPhoto?.publicId,
			title: look.name,
			quickStartId: look.projectId,
			description: look.name
		};
	});
